// открываем ссылку в текущем окне
$(document).on('click', '[data-link]', function (e) {
    location.href = $(this).attr('data-link');
    e.preventDefault();
});

// открываем ссылку в новом окне
$(document).on('click', '[data-link-blank]', function (e) {
    window.open($(this).attr('data-link-blank'), '_blank');
    e.preventDefault();
});
